import api from '.';
import downloadFile from '../functions/downloadFile';

interface QueryGetChecklistCreatorFiles {
  ids: number[];
  filename: string;
}

export async function getChecklistCreatorFiles({
  ids,
  filename
}: QueryGetChecklistCreatorFiles): Promise<void> {
  const { data } = await api.get(`checklist-creator-files/download`, {
    params: { ids },
    responseType: 'blob'
  });
  downloadFile({ data, contentType: data.type, filename });
}
